import type { LogEvent } from 'pino';
import type { Logger, LoggerOptions } from '@zg-rentals/logger-base';
import { ThrottledBatchWriter } from '@zg-rentals/util';
import { createLogger } from '@zg-rentals/logger-base';
import { isbot } from 'isbot';

export default function getBrowserLogger({ logPath, ...options }: LoggerOptions = {}): Logger {
  options.level ??= 'info';

  const bw = new ThrottledBatchWriter(async (batch: Array<LogEvent>) => {
    if (logPath && typeof window !== 'undefined' && !isbot(window.navigator.userAgent)) {
      const body = JSON.stringify(batch);

      if (navigator.sendBeacon) {
        navigator.sendBeacon(logPath, new Blob([body], { type: 'application/json' }));
      } else {
        fetch(logPath, { body, method: 'POST', keepalive: true, headers: { 'content-type': 'application/json' } });
      }
    }
  }, 2000);

  options.browser ??= {};
  options.browser.transmit ??= {
    send: (_, logEvent) => {
      if (logEvent.level.value >= logger.levelVal) {
        bw.write(logEvent);
      }
    },
  };

  const logger = createLogger(options);

  return logger;
}
